import React, { useState } from "react";
import CommentField from "../inputs/CommentField";
import Button from "../buttons/Button";
import Tabs from "../../ui/tabs/Tabs";
import TabPanels from "../../ui/tabs/TabPanels";
import TabPanel from "../../ui/tabs/TabPanel";
import AlarmTabs from "../../ui/tabs/AlarmTabs";
import { SIDEPANEL_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalData?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  comments?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addAlarmComment?: any;
}

const AlarmMetaData = ({
  additionalData,
  comments,
  addAlarmComment,
}: IProps) => {
  const [comment, setComment] = useState("");
  const commentsReversed = comments ? [...comments] : [];
  commentsReversed.reverse();
  return (
    <div className="comment-wrapper">
      <Tabs>
        <AlarmTabs
          numOfComments={comments ? comments.length : 0}
          addAlarmComment={addAlarmComment}
        />
        {comments?.length || addAlarmComment ? (
          <TabPanels>
            <TabPanel>
              <div className="info-wrapper">
                {addAlarmComment ? (
                  <div className="info-comment">
                    <CommentField
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder={
                        SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.commentField
                          .placeholder
                      }
                    />
                    <Button
                      className="w-sm comment-btn"
                      label={
                        SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.commentField
                          .buttonLabel
                      }
                      disabled={!(comment && comment.length > 0)}
                      onClick={() => addAlarmComment(comment)}
                      dataCy={`${SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.commentField.buttonLabel}-`}
                    />
                  </div>
                ) : null}
                <div className="info-listing" data-cy="comments-listing">
                  {commentsReversed.flat(1).map((comment) => {
                    return (
                      <div
                        className="info-listitem"
                        key={comment.CreatedAt}
                        data-cy="comment-listitem"
                      >
                        <div className="info-top" data-cy="comment-topbar">
                          <div className="comment-info" data-cy="comment-info">
                            <span className="comment-marker" />
                            {comment.created_by || comment.USER}
                          </div>
                          <div
                            className="comment-datetime"
                            data-cy="comment-datetime"
                          >
                            {comment.created_at || comment.CreatedAt}
                          </div>
                        </div>

                        <ul className="info-bottom" data-cy="comment-items">
                          {comment.reason ? (
                            <li key={comment.reason} data-cy="comment-content">
                              {" "}
                              {comment.reason}{" "}
                            </li>
                          ) : null}
                          {comment.type ? (
                            <li key={comment.type} data-cy="comment-type">
                              {" "}
                              Type : {comment.type}{" "}
                            </li>
                          ) : null}
                          {comment.CONTENT ? (
                            <li key={comment.CONTENT} data-cy="comment-content">
                              {" "}
                              Content : {comment.CONTENT}{" "}
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="info-wrapper">
                <div className="addinfo-listing" data-cy="additonalInfo-list">
                  {additionalData ? (
                    <ul className="info-bottom" data-cy="comment-bottomBar">
                      {Object.keys(additionalData).map((key) => {
                        return (
                          <li data-cy={`additonalInfo-${key}`}>
                            <span> {key} </span> : {additionalData[key]}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>
              </div>
            </TabPanel>
          </TabPanels>
        ) : (
          <TabPanels>
            <TabPanel>
              <div className="info-wrapper">
                <div className="addinfo-listing" data-cy="additonalInfo-list">
                  {additionalData ? (
                    <ul className="info-bottom" data-cy="comment-bottomBar">
                      {Object.keys(additionalData).map((key) => {
                        return (
                          <li data-cy={`additonalInfo-${key}`}>
                            <span> {key} </span> : {additionalData[key]}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>
              </div>
            </TabPanel>
          </TabPanels>
        )}
      </Tabs>
    </div>
  );
};
export default AlarmMetaData;
